import React from 'react';
type RDReadyLogoProps = {
  className?: string;
};
export function RDReadyLogo({
  className = 'h-8 w-36'
}: RDReadyLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/goXh4WC1g7cVskJAYY8rDJ/RD_Ready_Logo.png" alt="RD Ready" className={`block h-full w-full object-contain object-left ${className}`} data-id="element-3759" />;
}